/**
 * Prevent the Escape key from closing a modal
 * @param {KeyboardEvent} event
 */
function handleEscapeKey(event: KeyboardEvent): void {
  if (event.key === 'Escape') {
    event.preventDefault();
  }
};

export function attachEventHandlers(dialog: HTMLElement): void {
  dialog.addEventListener('keydown', handleEscapeKey);
}
